import React from "react";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

import "./timeSelector.css";

export default class TimeSelector extends React.Component {
  #dragDebounceTimer;

  constructor(props) {
    super(props);

    this.state = {
      showSettings: false,
      videoInformation: {},
      seconds: null,
      playbackRate: 1.0,
    };

    this.toggleSettings = this.toggleSettings.bind(this);
    this.handleTimeSelection = this.handleTimeSelection.bind(this);
    this.handleChangePlaybackRate = this.handleChangePlaybackRate.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.playerContext !== prevProps.playerContext) {
      this.props.playerContext.onContextStateChanged(
        this.playerStateChanged.bind(this)
      );
    }
  }

  playerStateChanged(state) {
    this.setState({ ...state, seconds: null });
  }

  toggleSettings() {
    this.setState({ showSettings: !this.state.showSettings });
  }

  handleTimeSelection(e) {
    //we want to drag without constantly updating the video time, so use a debounce timer and simulate the seconds display
    const seconds = e.target.value;
    if (this.#dragDebounceTimer) {
      clearTimeout(this.#dragDebounceTimer);
      this.#dragDebounceTimer = null;
    } else {
      this.currentlyPlaying = this.props.playerContext.playing;
      this.props.playerContext.requestPause();
    }

    this.#dragDebounceTimer = setTimeout(() => {
      this.props.playerContext.requestTime(seconds);
      if (this.currentlyPlaying) {
        this.props.playerContext.requestPlay();
      }
      this.#dragDebounceTimer = null;
    }, 500);
    this.setState({ seconds });
  }

  handleChangePlaybackRate(e) {
    this.props.playerContext.requestPlaybackRate(e.target.value);
  }

  render() {
    if (!this.props.playerContext) return null;

    const seconds =
      this.state.seconds ??
      this.props.playerContext.videoInformation.videoPosition ??
      0;
    const videoLength = this.state.videoInformation.videoLength ?? 0;
    const playbackSpeedClass = classNames("playbackSpeed", {
      shown: this.state.showSettings,
    });

    return (
      <div className="timeSelector">
        <input
          className="scrubBar"
          type="range"
          min="0"
          max={isNaN(videoLength) ? 0 : videoLength}
          step="0.01"
          title="Time"
          value={isNaN(seconds) ? 0 : seconds}
          onInput={this.handleTimeSelection}
        ></input>
        <label className="timeDisplay">
          {new Date(seconds * 1000).toISOString().substr(14, 5)}
        </label>
        <div className={playbackSpeedClass}>
          <label>Rate</label>
          <select
            value={this.state.playbackRate ?? 1.0}
            onChange={this.handleChangePlaybackRate}
          >
            <option value={0.5}>0.5x</option>
            <option value={1.0}>1x</option>
            <option value={1.5}>1.5x</option>
            <option value={2.0}>2x</option>
          </select>
        </div>
        <FontAwesomeIcon icon={faCog} onClick={this.toggleSettings} />
      </div>
    );
  }
}
